import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=bb61a0ae&"
import script from "./UserView.vue?vue&type=script&lang=js&"
export * from "./UserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports